import React from 'react'
import * as rn from 'react-native'

import * as c from '../../../common'
import * as r from '../../../react-utils'

import * as m from '@mui/material'
import Entypo from 'react-native-vector-icons/Entypo'
import { useParams } from 'react-router-dom'

import * as gs from '../../../app/gStyles'
import * as cpm from '../../../app/components'

export type ContractLogoProps = c.r<{
  isPDF?: boolean
  size: 's' | 'm' | 'l'
}>

export default React.memo<ContractLogoProps>(function ContractLogo({
  isPDF,
  size,
}) {
  const { customerID } = useParams<'customerID'>()

  const {
    contractCompaniesCurrState,
    contractCompaniesCurrStateArr,
    contractCompanyShortName,
    contractCompanyFull,
    handleContractCompany,
  } = r.useContractCompany(customerID!)

  const companySelected = !!contractCompanyShortName
  const companySelectedIsInCurrList =
    !!contractCompaniesCurrState[contractCompanyShortName]
  const moreThanOneCompanyAvail = React.useMemo(
    (): boolean => c.keys(contractCompaniesCurrState).length > 1,
    [contractCompaniesCurrState],
  )

  const [choosingCompany, , toggleChoosingCompany] = r.useBool(false)

  return (
    <>
      <rn.Pressable onPress={toggleChoosingCompany} style={gs.rowCentered}>
        {companySelected && companySelectedIsInCurrList ? (
          <img
            alt={contractCompanyShortName}
            src={contractCompanyFull.logo}
            style={(() => {
              if (size === 'l') return sx.logoLarge
              if (size === 'm') return sx.logoMedium
              return sx.logoSmall
            })()}
          />
        ) : (
          <cpm.Text colorScheme="light">
            Click here to select a company for the contract
          </cpm.Text>
        )}

        {!isPDF && (moreThanOneCompanyAvail || !contractCompanyShortName) && (
          <>
            {gs.colGap8}

            <Entypo
              color={c.light.canvas.opaque}
              name="select-arrows"
              size={18}
              style={gs.alignSelfEnd}
            />
          </>
        )}
      </rn.Pressable>

      <m.Select
        onChange={handleContractCompany}
        onClose={toggleChoosingCompany}
        onOpen={toggleChoosingCompany}
        open={choosingCompany}
        renderValue={c.alwaysNull}
        style={sx.select}
        value={contractCompanyShortName}
      >
        {contractCompaniesCurrStateArr.map(({ logo, longName, shortName }) => (
          <m.MenuItem key={shortName} style={sx.menuItem} value={shortName}>
            <img alt={longName} src={logo} style={{ width: 100, height: 40 }} />

            <rn.View style={gs.rowCentered}>
              {gs.colGap8}
              <cpm.Text colorScheme="light" size={18}>
                {longName}
              </cpm.Text>
            </rn.View>

            {gs.rowGap8}
          </m.MenuItem>
        ))}
      </m.Select>
    </>
  )
})

const sx = {
  logoLarge: { width: 200 },
  logoMedium: { width: 128 },
  logoSmall: { width: 200 },
  menuItem: {
    alignItems: 'stretch',
    flexDirection: 'row',
    paddingBottom: 24,
    paddingTop: 24,
  } as const,
  select: { ...gs.width72, height: 0, opacity: 0 },
}
